(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["utils/view-avatar"] = factory();
	else
		root["utils/view-avatar"] = factory();
})(globalThis, () => {
return 